import React from "react";
import { motion } from "framer-motion";

function CardElement(props) {
  const title = props.title;
  const paragraph = props.paragraph;
  const icon = props.icon;


  return (
    <>
      <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} >
        <div class="flex justify-center dark:bg-gray-900">
          <div class="p-6 rounded-lg shadow-lg bg-white dark:bg-gray-800 max-w-sm">
            <div class="text-gray-900 dark:text-white text-xl leading-tight font-medium my-2">
              <div className="rounded-full w-10 h-10 bg-cyan-600 place-items-end">
                <p className="text-white p-2 ">{icon}</p>
              </div>
              <div className="my-4">{title}</div>
            </div>
            <p class="text-gray-700 dark:text-gray-300 text-base my-4">
              {paragraph}
            </p>
          </div>
        </div>
      </motion.div>
    </>
  );
}

export default CardElement;
